import React, {
  useContext, useEffect, useRef, useState,
} from 'react';
import {
  Button, Col, Card, OverlayTrigger, Row, Tooltip, Container,
} from 'react-bootstrap';
import { faCamera, faUser } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';
import coverSrc from '../../../../../assets/img/generic/bg-2.jpg';
import ChangePassword from './ChangePassword';
import useEditor from '../../../../../containers/newEditor/hook/editor';
// eslint-disable-next-line no-unused-vars
import meta from '../../../../../meta';
import { EditorControls, editorHooks } from '../../../../../containers/basicEditor/editorControls';
import EditorContainer from '../../../../../containers/newEditor/editorContainer';
import Background from '../../../common/Background';
import Avatar from '../../../common/Avatar';
import IconButton from '../../../common/IconButton';
import { CiatAppContext } from '../../../../../providers';

const uploadButtonStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: '2',
};

function Settings() {
  const { currentUser, refreshCurrentUser } = useContext(CiatAppContext);
  const [showPassword, setShowPassword] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [avatarImg, setAvatarImg] = useState(null);
  const [avatarChanged, setAvatarChanged] = useState(false);
  const fileInputRef = useRef(null);

  const {
    data,
    actions,
    fields, nonFieldErrors, options, isNew,
    changed, systemErrors, fieldErrors,
    loading,
  } = useEditor({
    backendURL: meta.cat.user.backendURL,
    // backendURL: '/api/auth/user/', правильно таке посилання
    id: currentUser.id,
  });

  useEffect(
    () => {
      if (Object.keys(data).length !== 0 && !avatarChanged
       && (typeof data.m_avatar) === 'string'
          && 'filename' in data.avatar
      ) { setAvatarImg(data.m_avatar); }
    },
    [data, avatarChanged],
  );

  const closeShowPassword = () => {
    setShowPassword(false);
  };

  const handleHover = () => {
    setIsHovered(true);
  };

  const handleHoverEnd = () => {
    setIsHovered(false);
  };

  const handleFileUpload = async () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
      fileInputRef.current.click(); // Trigger the file input click event
    }
  };

  const onChangeAvatar = (filename, file) => {
    actions.onChange(
      () => (
        {
          avatar: {
            filename,
            file,
          },
        }),
    );
    setAvatarImg(file);
    setAvatarChanged(true);
  };

  const getFileUrl = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => onChangeAvatar(file.name, reader.result);
    reader.readAsDataURL(file);
  };

  const handleInputChange = async (event) => {
    const file = event.target.files[0]; // Get the selected file
    getFileUrl(file);
  };

  const overlayStyle = {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    display: isHovered ? 'block' : 'none',
    background: 'rgba(0, 0, 0, 0.5)',
    borderRadius: '50%',
    zIndex: '1',
  };

  const onChange = (v) => {
    const user = data.user ? {
      ...data.user,
      ...v(),
    } : {
      ...v(),
    };
    actions.onChange({
      ...data,
      user: {
        ...user,
      },
    });
  };

  const editorStringHooks = (name) => editorHooks.useStringInputProps(
    name,
    Object.keys(data).length !== 0 ? data.user : {},
    fields ? fields.user.children : {},
    fieldErrors,
    onChange,
  );
  const firstName = editorStringHooks('first_name');
  const lastName = editorStringHooks('last_name');
  const email = editorStringHooks('email');

  return (
    <EditorContainer
      isNew={isNew}
      name={options.name}
      repr={data.repr}
      isLoading={loading}
      err={systemErrors}
      nonFieldErrors={nonFieldErrors}
      onClearNonFieldErrors={actions.onClearNonFieldErrors}
      onClearErrors={actions.onClearErrs}
      onClose={actions.onClose}
      changed={changed}
    >
      <Card.Body>
        <Card.Header
          className="position-relative min-vh-25 mb-7"
        >
          <Background image={coverSrc} className="rounded-3 rounded-bottom-0" />
          <div
            className="avatar-container"
            onMouseEnter={handleHover}
            onMouseLeave={handleHoverEnd}
          >
            <Avatar
              size="5xl"
              className="avatar-profile"
              icon={faUser}
              src={avatarImg}
              mediaClass="img-thumbnail shadow-sm"
            >
              <div style={overlayStyle}>
                <OverlayTrigger
                  overlay={(
                    <Tooltip style={{ position: 'fixed' }} id="previousTooltip">
                      Завантажити фото
                    </Tooltip>
                  )}
                >
                  <div style={uploadButtonStyle}>
                    <IconButton
                      className="mb-0"
                      variant="light"
                      size="sm"
                      icon={faCamera}
                      onClick={handleFileUpload}
                    />
                    <input
                      ref={fileInputRef}
                      type="file"
                      style={{ display: 'none' }}
                      onChange={handleInputChange}
                    />
                  </div>
                </OverlayTrigger>
              </div>
            </Avatar>
          </div>
        </Card.Header>
        <div className="d-flex justify-content-end">
          <NavLink
            to="/changePassword/"
          >
            <Button
              variant="link"
            // onClick={() => setShowPassword(!showPassword)}
            >
              Змінити пароль
            </Button>
          </NavLink>
        </div>
        <Container fluid className="border border-top-0 pb-3 rounded-bottom">
          <Row>
            <Col lg={showPassword ? 8 : 12}>
              <Row>
                <Col>
                  <EditorControls.StringInput {...firstName} />
                </Col>
                <Col>
                  <EditorControls.StringInput {...lastName} />
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <EditorControls.StringInput {...email} />
                </Col>
              </Row>
              <Row className="justify-content-end align-items-center pt-2">
                <Col
                  md={11}
                  lg={8}
                  xl={4}
                  className="pb-2 text-end"
                >
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={!changed}
                    onClick={async () => {
                      await actions.onSaveWithoutExit();
                      refreshCurrentUser();
                    }}
                  >
                    Зберегти зміни
                  </Button>
                </Col>
              </Row>
            </Col>
            { showPassword && (
            <Col lg={4}>
              <div className="sticky-sidebar">
                <ChangePassword closeShowPassword={closeShowPassword} />
              </div>
            </Col>
            )}
          </Row>
        </Container>
      </Card.Body>
    </EditorContainer>
  );
}

export default Settings;
